export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      screenConfigMst: {
        screenConfigMstId: 3,
        screenConfigMstUuid: "screenconfigmst003",
        screenConfigName: "コミュニティサポート系ライブカメラ画面",
        deviceTypeName: "normal",
        serviceTypeName: "サービス名",
        screenOrientationKbn: 0,
        screenConifgStatus: 1,
        screenWidth: 1280,
        screenHeight: 800,
        screenLayout: {}
      }
    }
  }
}